// extracted by mini-css-extract-plugin
module.exports = {"bullet-item-wrapper":"_80ad21f8ef--bullet-item-wrapper--bY7l8","container":"_80ad21f8ef--container--gnV5k","col":"_80ad21f8ef--col--QWo2Q"};